import React from 'react';
import useQuery from './useQuery';
import useMutation from './useMutation';

export default WrappedComponent => {
  const hocComponent = props => {
    const query = useQuery('', { init: false });
    const mutation = useMutation();

    return <WrappedComponent query={query} mutation={mutation} {...props} />;
  };

  hocComponent.fetchData = WrappedComponent.fetchData;

  return hocComponent;
};
